<style scoped>
    .mainBox{
        /*background: #fff;*/
        color: #333;
        font-size: .32rem;
        line-height: .48rem;
    }
    .fff{
        padding: .38rem;
        background: #fff;
    }
    .title{
        font-size: .36rem;
        font-weight: bold;
        margin: .18rem 0 .38rem;
    }
    .read{
        margin: .26rem 0 0;
    }
    .inputBox{
        display: flex;
        align-items: center;
        height: 1.12rem;
        border-bottom: .02rem solid #F0F0F0;
    }
    .inputBox:last-child{
        border-bottom: 0;
    }
    .word{
        width: 2.2rem;
        margin-right: .5rem;
        font-size: .28rem;
        color: #4D4D4D;
    }
    .inputBox input{
        font-size: .28rem;
        color: #333;
        border: none;
    }
    input::placeholder{
        color: #ccc;
    }

    .inputBox img{
        width: 4.1rem;
        height: 1.12rem;
        object-fit: cover;
    }
    .btn{
        width: 6.74rem;
        height: .88rem;
        border-radius: .44rem;
        background: #A0C6FE;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: .28rem;
        color: #fff;
    }
    .btn.active{
        background: #408BFB;
    }

    .signatureBox{
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        overflow: hidden;
        background: #fff;
        z-index: 100;
        display: flex;
        flex-direction: column;
    }
    .canvasBox{
        padding: 10px 5px;
        box-sizing: border-box;
        flex: 1;
    }
    canvas{
        border: 1px solid #71b900;
    }
    .btnBox{
        height: 30px;
        padding: 5px;
        text-align: right;
        line-height: 30px;
    }
    .btnBox button:first-of-type{
        border: 1px solid #71b900;
        background: transparent;
        border-radius: 4px;
        padding: 5px 10px;
    }
    .btnBox button:last-of-type{
        border: 1px solid #71b900;
        background: #71b900;
        color: #fff;
        border-radius: 4px;
        padding: 5px 10px;
    }
    @media only screen and (min-width: 750px){
        .signatureBox{
            position: absolute;
            top: 0px;
            left: 0px;
            width: 100%;
            min-height: 100%;
            box-sizing: border-box;
            overflow: visible;
        }
    }
    .inputBigBox{
        background: #fff;
        margin-top: .16rem;
        padding: .38rem;
        padding-bottom: 0;
    }

    .c-btnBox{
        height: 1.5rem;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    #xlfgt{
        width: 100%;
        object-fit: cover;
    }
</style>
<template>
    <div style="padding-top: .98rem">
        <topbar text="心理咨询设置协议"></topbar>
        <div class="mainBox" v-if="!showStatus">
            <div class="fff" v-if="companyId!=10002">
                <div class="title">心理咨询设置协议</div>
                <div>1.协议双方通过签署本协议以规范心理咨询的过程,保证心理咨询的有效进行。</div>
                <div>2.咨询形式可自由选择。每次咨询50分钟，每周咨询1次。</div>
                <div>3.咨询对象为在校全日制学生。咨询仅限本人使用，为一对一个别咨询，不得转介给他人或者在咨询过程中将他人拉入咨询。</div>
                <div>4.来访者请准时在预约时间接受咨询，迟到不延迟咨询时间，咨询准时结束。来访者如要改变或取消咨询时间, 请及时在系统中操作，否则将取消已经获得的咨询资格。</div>
                <div>5.咨询师如需改变或取消已经预约好的咨询时间,须提前通知来访者。</div>
                <div>6.来访者若选择网络咨询，在开始前尽量保证稳定的网络条件、通讯设备以及独立安静的房间，因网络故障或者不可抗力因素导致咨询质量受损，咨询时间无法延长或更改。</div>
                <div>7.来访者不得对咨询过程进行录音录像，也不得在咨询过程中攻击、辱骂咨询师或传播不良、非法信息，否则咨询师有权立刻终止咨询，并保留依法申诉的权利。</div>
                <div>8.在心理咨询过程中,咨询师要为来访者的隐私保密,来访者在咨询过程中所叙述的经历,体验,未经其本人同意,咨询师不得公布或传播这些信息.如确因学术交流或其他因素的需要,要报告该案例,需隐去可能辨认出来访者的个人信息。</div>
                <div>9．如来访者的行为可能对自己或他人构成严重伤害,或出于司法原因作为呈堂证供，则咨询师可以突破保密原则，向有关单位报告来访者的情况。除此之外，咨询记录将妥善保存在本中心，不提供给包括来访者在内的任何人与机构。</div>
                <div>10.来访者需要提供一位紧急联系人，并保证信息的真实、准确、有效性。在紧急情况下（如来访者存在危及自身或他人生命的情况等），心理中心可能与联系人取得联系，通报来访者的状况，但不会将来访者的隐私内容透露给该联系人。如果来访者提供的联系人信息为无效信息，由此导致的一切后果均将由来访者本人承担，与咨询师、心理中心及学校无关。</div>
                <div>11.心理咨询中心仅提供涉及学习生活、个人成长和自我发展类的相关问题心理评估和咨询，不提供包括精神鉴定、诊断、处方精神类药物、出具资格证明、对严重心理障碍患者的长程心理治疗等在内的服务内容。如果来访者可能患有某种精神障碍，请先去相关专科医院就诊就治。</div>
                <div class="read">以上全部规定，本人已经阅读，并愿意遵守！</div>
            </div>
            <img src="~assets/xlfgt.png" v-if="companyId==10002" id="xlfgt" alt="">


            <div class="inputBigBox">
                <div class="inputBox">
                    <div class="word">紧急联系人</div>
                    <input type="text" placeholder="请输入联系人姓名" v-model="emergencyContact">
                </div>
                <div class="inputBox">
                    <div class="word">与来访者关系</div>
                    <input type="text" placeholder="如：母女" v-model="relation">
                </div>
                <div class="inputBox">
                    <div class="word">紧急联系人电话</div>
                    <input type="text" placeholder="请输入联系人电话" v-model="emergencyContactPhone">
                </div>
                <div class="inputBox">
                    <div class="word">来访者签名</div>
                    <img :src="EnvUrl+visitorSignature" alt="" v-if="visitorSignature" @click="aa()">
                    <input  @click="aa()" type="text" placeholder="点击签名" v-if="!visitorSignature">
                </div>
            </div>
            <div class="c-btnBox">
                <div class="btn" :class="{active:emergencyContact&&relation&&emergencyContactPhone&&visitorSignature}" @click="read">我已阅读并同意遵守</div>
            </div>

        </div>

        <div class="signatureBox" v-show="showStatus">
            <div class="canvasBox" ref="canvasHW">
                <canvas @touchstart='touchStart'
                        @touchmove='touchMove'
                        @touchend='touchEnd'
                        ref="canvasF"
                        @mousedown="mouseDown"
                        @mousemove="mouseMove"
                        @mouseup="mouseUp"></canvas>
                <div class="btnBox">
                    <button @click="overwrite">重写</button>
                    <button @click="saveWrite">提交签名</button>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
    import {getSource, getSources} from "../api"

    import noMoreData from 'components/no-more-data'
    import topbar from 'components/topbar'
    import moment from 'moment/moment'

    import {Swiper, Slide} from 'vue-swiper-component';
    import {serialize} from 'utils/index'

    export default {
        data() {
            return {
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
                EnvUrl: `https://cdn.ysqingxin.com/`,
                emergencyContact:'',
                relation:'',
                emergencyContactPhone:'',
                visitorSignature:'',
                agreeId:'',
                companyId:'',
                showStatus:false,
                points:[],
                canvasTxt:null,
                startX:0,
                startY:0,
                moveY:0,
                moveX:0,
                endY:0,
                endX:0,
                w:null,
                h:null,
                isDown:false
            }
        },
        components: {
            noMoreData,
            topbar,
            Swiper,
            Slide,
        },
        filters: {
            time(value) {
                let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
                return transTime
            },
        },
        computed: {},
        methods: {
            aa(){
                console.log(111111)
              this.showStatus=true
            },
            saveWrite(){
                var dataurl = this.$refs.canvasF.toDataURL("image/png");
                console.log("保存签名成功" + dataurl);
                this.getToken(dataurl)

            },
            async getToken(dataurl){
                var that=this;
                var xhr = new XMLHttpRequest();
//设置请求的类型及url
//post请求一定要添加请求头才行不然会报错

                xhr.open('post', '/bear-scale/api/qiniu/obtainPictureUploadToken.json' );
                xhr.setRequestHeader("Content-type","application/x-www-form-urlencoded");
//发送请求
                xhr.send('');
                xhr.onreadystatechange = function () {
                    console.log(xhr)
                    // 这步为判断服务器是否正确响应
                    if (xhr.readyState == 4) {
                        let data=JSON.parse(xhr.responseText)
                        that.putb64(dataurl,data.token)
                    }
                };
            },
            async putb64(pic,token){
                var that=this;
                var pic = pic.replace(/^.*?,/, '');
                var url = "https://up-z0.qiniup.com/putb64/-1"; //非华东空间需要根据注意事项 1 修改上传域名
                var xhr = new XMLHttpRequest();
                xhr.open("POST", url, true);
                xhr.setRequestHeader("Content-Type", "application/octet-stream");
                xhr.setRequestHeader("Authorization", `UpToken ${token}`);
                xhr.send(pic);

                xhr.onreadystatechange=function(){
                    if (xhr.readyState==4){
                        let data=JSON.parse(xhr.responseText)
                        that.visitorSignature=data.key;

                        that.toBottom()
                        // document.querySelector('#app').scrollTo(0, 2000);
                        console.log(that.visitorSignature)
                    }
                }

            },
            backHome(){
                window.history.back();
            },
            //电脑设备事件
            mouseDown(ev){
                ev = ev || event;
                ev.preventDefault();
                console.log(ev);
                if(1){
                    let obj={
                        x:ev.offsetX,
                        y:ev.offsetY
                    };
                    console.log(obj);
                    this.startX=obj.x;
                    this.startY=obj.y;
                    this.canvasTxt.beginPath();
                    this.canvasTxt.moveTo(this.startX, this.startY);
                    this.canvasTxt.lineTo(obj.x, obj.y);
                    this.canvasTxt.stroke();
                    this.canvasTxt.closePath();
                    this.points.push(obj);
                    this.isDown=true;
                }
            },
            //移动设备事件
            touchStart(ev){
                ev = ev || event;
                ev.preventDefault();
                if(ev.touches.length == 1) {
                    let obj={
                        x:ev.targetTouches[0].clientX,
                        y:ev.targetTouches[0].clientY
                    };
                    this.startX=obj.x;
                    this.startY=obj.y;
                    this.canvasTxt.beginPath();
                    this.canvasTxt.moveTo(this.startX, this.startY);
                    this.canvasTxt.lineTo(obj.x, obj.y);
                    this.canvasTxt.stroke();
                    this.canvasTxt.closePath();
                    this.points.push(obj);
                }
            },
            //电脑设备事件
            mouseMove(ev){
                ev = ev || event;
                ev.preventDefault();
                if(this.isDown){
                    let obj={
                        x:ev.offsetX,
                        y:ev.offsetY
                    };
                    this.moveY=obj.y;
                    this.moveX=obj.x;
                    this.canvasTxt.beginPath();
                    this.canvasTxt.moveTo(this.startX, this.startY);
                    this.canvasTxt.lineTo(obj.x, obj.y);
                    this.canvasTxt.stroke();
                    this.canvasTxt.closePath();
                    this.startY=obj.y;
                    this.startX=obj.x;
                    this.points.push(obj);
                }
            },
            //移动设备事件
            touchMove(ev){
                ev = ev || event;
                ev.preventDefault();
                if(ev.touches.length == 1) {
                    let obj={
                        x:ev.targetTouches[0].clientX,
                        y:ev.targetTouches[0].clientY
                    };
                    this.moveY=obj.y;
                    this.moveX=obj.x;
                    this.canvasTxt.beginPath();
                    this.canvasTxt.moveTo(this.startX, this.startY);
                    this.canvasTxt.lineTo(obj.x, obj.y);
                    this.canvasTxt.stroke();
                    this.canvasTxt.closePath();
                    this.startY=obj.y;
                    this.startX=obj.x;
                    this.points.push(obj);
                }
            },
            //电脑设备事件
            mouseUp(ev){
                ev = ev || event;
                ev.preventDefault();
                if(1){
                    let obj={
                        x:ev.offsetX,
                        y:ev.offsetY
                    };
                    this.canvasTxt.beginPath();
                    this.canvasTxt.moveTo(this.startX, this.startY);
                    this.canvasTxt.lineTo(obj.x, obj.y);
                    this.canvasTxt.stroke();
                    this.canvasTxt.closePath();
                    this.points.push(obj);
                    this.points.push({x:-1,y:-1});
                    this.isDown=false;
                }
            },
            //移动设备事件
            touchEnd(ev){
                ev = ev || event;
                ev.preventDefault();
                console.log(ev);
                if(ev.touches.length == 1) {
                    let obj={
                        x:ev.targetTouches[0].clientX,
                        y:ev.targetTouches[0].clientY
                    };
                    this.canvasTxt.beginPath();
                    this.canvasTxt.moveTo(this.startX, this.startY);
                    this.canvasTxt.lineTo(obj.x, obj.y);
                    this.canvasTxt.stroke();
                    this.canvasTxt.closePath();
                    this.points.push(obj);
                    this.points.push({x:-1,y:-1});
                }
            },
            //重写
            overwrite(){
                this.canvasTxt.clearRect(0, 0, this.$refs.canvasF.width, this.$refs.canvasF.height);
                this.points=[];
            },

            read(){
                if(this.emergencyContact&&this.relation&&this.emergencyContactPhone&&this.visitorSignature){
                    this.userDoBespeakAgree()
                }
            },
            async userDoBespeakAgree() {
                let data = await getSources("/bear-scale/api/scaleUserBespeak/userDoBespeakAgree.json", {
                    userId:localStorage.getItem('userId'),
                    agreeId:this.agreeId,
                    emergencyContact:this.emergencyContact,
                    relation:this.relation,
                    emergencyContactPhone:this.emergencyContactPhone,
                    visitorSignature:this.visitorSignature,
                    bespeakId:this.$route.query.bespeakId
                });
                if (data.status === 0) {
                    this.$router.replace(`/consult`)
                }else{
                    alert(data.msg)
                }
            },
            toBottom(){

                this.showStatus=false;
                setTimeout(()=>{
                    document.documentElement.scrollTop = document.body.scrollTop = 2000;
                },50)
            },
            async userBespeakAgree() {
                let data = await getSources("/bear-scale/api/scaleUserBespeak/userBespeakAgree.json", {userId:localStorage.getItem('userId')});
                if (data.status === 0) {
                    if(data.scaleUserBespeakAgree){
                        this.agreeId=data.scaleUserBespeakAgree.agreeId
                        this.emergencyContact=data.scaleUserBespeakAgree.emergencyContact
                        this.relation=data.scaleUserBespeakAgree.relation
                        this.emergencyContactPhone=data.scaleUserBespeakAgree.emergencyContactPhone
                        this.visitorSignature=data.scaleUserBespeakAgree.visitorSignature
                    }

                    // history.back()
                } else {
                    alert(data.msg)
                }
            },
        },
        destroyed(){

        },
        mounted() {

            this.userBespeakAgree();
            let canvas=this.$refs.canvasF;
            console.log(this.$refs.canvasHW.offsetHeight)
            console.log(this.$refs.canvasHW.offsetWidth)
            canvas.height = 200;
            canvas.width =365;
            this.canvasTxt=canvas.getContext("2d");
            // 在canvas绘制前填充白色背景
            this.canvasTxt.fillStyle = "#fff";
            this.canvasTxt.fillRect(0, 0, canvas.width, canvas.height);
            this.companyId = localStorage.getItem('companyId')?localStorage.getItem('companyId'):''
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/agreement.vue?0557907a